module.exports = __webpack_public_path__ + "img/edge_activites_atelier.8cda3dd4.svg";